import React, { useState, useEffect } from "react";
import "./style.less";
import webLogo from "@/assets/loginLogo.svg";
import gysj from "@/assets/icons/gysj.svg";
import zxyh from "@/assets/icons/zxyh.svg";
import banquan from "@/assets/icons/banquan.svg";
import { useNavigate } from "react-router-dom";

const Component = (props: any) => {
  const history = useNavigate();
  return (
    <>
      <div className="maiiPageTitle">
        <img src={webLogo} alt="" />
      </div>
      <div className="mainPage">
        <div className="mainPageInner">
          <div className="maiiPageContent">
            <div className="ci" onClick={() => history("/project")}>
              <div className="ci_logo">
                <img src={gysj} alt="" />
              </div>
              <div className="ci_text">工艺设计</div>
            </div>
            <div className="ci" onClick={() => history("/operation")}>
              <div className="ci_logo">
                <img src={zxyh} alt="" />
              </div>
              <div className="ci_text">在线优化</div>
            </div>
          </div>
          
        </div>
      </div>
      <div className="bottomTxt"><img src={banquan} /><b>领碳科技</b><span>Zero Carbon Energy Environmental Protection Technology Co.,Ltd.</span></div>
    </>
  );
};

export default Component;
